<!-- <ul class="nav-links__list">
    <app-sidebar class="hidden md:block w-64 text-white h-screen"></app-sidebar>

    <div class="menu_nav">
        <div class="profile_cls">
            <button class="btn-2 rounded-pill Sp_cls">
                <a class="nav-links__item-link" [routerLink]="'/account/Support'">
                    <div class="nav-links__item-body2">
                        <i class="fas fa-headset text-[#E5E7EB] text-[25px] mx-[4px]" tooltip="Support"></i>
                    </div>
                </a>
            </button>

            <li class="nav-links__item" (click)="toggleDropdown($event)" style="cursor: pointer; position: relative;">
                <a class="nav-links__item-link">
                    <i class="fas fa-user-circle text-[33px] bg-[#E5E7EB] rounded-full "></i>
                </a>

                <div *ngIf="dropdownOpen" class="dropdown-menu">
                    <a class="dropdown-item" [routerLink]="'/account/password'">
                        <i class="fas fa-lock"></i> Change Password
                    </a>
                    <a class="dropdown-item" [routerLink]="'/account/profile'">
                        <i class="fas fa-user"></i> Edit Profile
                    </a>
                    <a class="dropdown-item" (click)="Logout()">
                        <i class="fas fa-sign-out-alt"></i> Logout
                    </a>
                </div>
            </li>
        </div>
    </div>
</ul> -->











<ul class="nav-links__list">
    <app-sidebar class="hidden md:block w-64 text-white h-screen"></app-sidebar>

    <!-- <div class="menu_nav">
        <div class="profile_cls">
            <li class="nav-links__item" (click)="toggleDropdown($event)" style="cursor: pointer; position: relative;">
                <a class="nav-links__item-link">
                    <i class="fas fa-user-circle text-[33px] bg-[#E5E7EB] rounded-full"></i>
                </a>

                <div *ngIf="dropdownOpen" class="dropdown-menu">
                    <a class="dropdown-item" [routerLink]="'/account/Support'">
                        <i class="fas fa-headset"></i> Support
                    </a>
                    <a class="dropdown-item" [routerLink]="'/account/password'">
                        <i class="fas fa-lock"></i> Change Password
                    </a>
                    <a class="dropdown-item" [routerLink]="'/account/profile'">
                        <i class="fas fa-user"></i> Edit Profile
                    </a>
                    <a class="dropdown-item" (click)="Logout()">
                        <i class="fas fa-sign-out-alt"></i> Logout
                    </a>
                </div>
            </li>
        </div>
    </div> -->
</ul>
